import { forwardRef, type HTMLAttributes } from "react";

import { cn } from "@/lib/cn";

export type BadgeVariant = "default" | "success" | "warn" | "error" | "info";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

// v2 pill: 22px rounded-full chip with semantic background tint.
const variantClasses: Record<BadgeVariant, string> = {
  default:
    "bg-[var(--surface-2)] text-[var(--ink-2)] border border-[var(--line)]",
  success:
    "bg-[var(--pos-bg)] text-[var(--pos)] border border-transparent",
  warn:
    "bg-[var(--warn-bg)] text-[var(--warn)] border border-transparent",
  error:
    "bg-[var(--neg-bg)] text-[var(--neg)] border border-transparent",
  info:
    "bg-[var(--info-bg)] text-[var(--indigo-2)] border border-transparent",
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, variant = "default", ...props },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(
        "inline-flex h-[22px] items-center gap-1 rounded-full px-2",
        "font-sans text-[11px] font-medium tracking-[0.01em]",
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  );
});
